import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CertificateService } from 'app/services/models/certificate.service';

@Component({
  selector: 'app-certificate-list',
  templateUrl: './certificate-list.component.html',
  styleUrls: ['./certificate-list.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CertificateListComponent implements OnInit {

  certificates: any[] = [];
  totalCount: number;
  public pageBasic = 1;  // Page number
  public selectedSize = 12;
  public searchValue = '';
  constructor(@Inject('backendUrl') public backendUrl: string,
    private certificateService: CertificateService) { }

  async ngOnInit() {
    await this.getAllCertificate(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async getAllCertificate(page, size, search) {
    const data = await this.certificateService.gelAllCertificates(page, size, search);
    console.log(data);
    this.certificates = data.certificates;
    this.totalCount = data.totalCount;
  }

  async onPageChange(pageNumber: number) {
    this.pageBasic = pageNumber;
    await this.getAllCertificate(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  downloadFile(filePath: string): void {
    const link = document.createElement('a');
    link.href = this.backendUrl + filePath;
    link.download = filePath; // İndirme için dosya adını belirliyoruz
    link.click();
  }

  isFlipped = false;

  toggleFlip(index: number) {
    this.certificates[index].isFlipped = !this.certificates[index].isFlipped;
  }
}
